export interface RouteAnalyticsSummary {
  route: string;
  totalRequests: number;
  successCount: number;
  errorCount: number;
  lastActivityAt: string | null;
}

export interface RouteAnalyticsResult {
  routes: RouteAnalyticsSummary[];
  totalRoutes: number;
  totalRequests: number;
  computedAt: string;
  resultMayBePartial: boolean;
}

export type RouteAnalyticsTimePreset =
  | "1h"
  | "6h"
  | "12h"
  | "24h"
  | "7d"
  | "custom";

export const ROUTE_ANALYTICS_TIME_PRESETS: readonly {
  id: Exclude<RouteAnalyticsTimePreset, "custom">;
  label: string;
  hours: number;
}[] = [
  { id: "1h", label: "Last 1 hour", hours: 1 },
  { id: "6h", label: "Last 6 hours", hours: 6 },
  { id: "12h", label: "Last 12 hours", hours: 12 },
  { id: "24h", label: "Last 24 hours", hours: 24 },
  { id: "7d", label: "Last 7 days", hours: 24 * 7 },
] as const;

export const DEFAULT_ROUTE_ANALYTICS_PRESET: Exclude<RouteAnalyticsTimePreset, "custom"> = "24h";
